export default "__VITE_ASSET__836d7049__"